module.exports = __webpack_public_path__ + "img/check-success.d3e3cfc6.svg";